import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';

interface UserPermissions {
  isMaster: boolean;
  isLoading: boolean;
}

export const useUserPermissions = (): UserPermissions => {
  const { user } = useAuth();
  const [isMaster, setIsMaster] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkUserPermissions = async () => {
      if (!user?.email) {
        setIsMaster(false);
        setIsLoading(false);
        return;
      }

      try {
        // Buscar informações do usuário para verificar se é master
        const response = await api.get('/aprovadores');
        const aprovadores = response.data;

        const userAprovador = aprovadores.find((aprovador: any) => aprovador.email === user.email);
        setIsMaster(userAprovador?.perfil_master === 1);
      } catch (error) {
        console.error('Erro ao verificar permissões do usuário:', error);
        setIsMaster(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkUserPermissions();
  }, [user?.email]);

  return { isMaster, isLoading };
};
